// Předdefinované fonty (názvy pro Tailwind)
import {
  layoutsSvgPreviews,
  layoutsSvgPreviewsH,
} from './components/Configurator/Preview/MultipleLayouts/LayoutsSvgPreviews';

export const fonts = [
  { name: 'Roboto', class: 'font-sans' },
  { name: 'Montserrat', class: 'font-mono' },
  { name: 'Dancing Script', class: 'font-dancing' }, // budete muset doplnit do tailwind.config.js
  { name: 'Playfair Display', class: 'font-serif' },
];

// Pro jednoduchost: používat font-family přímo
export const fontFamilies = {
  Roboto: "'Roboto', sans-serif",
  Montserrat: "'Montserrat', monospace",
  'Dancing Script': "'Dancing Script', cursive",
  'Playfair Display': "'Playfair Display', serif",
};

export const glassTypes = [
  { name: 'Vlastní', type: 'classic' },
  { name: 'Pro páry', type: 'pair' },
  { name: 'Písnička', type: 'music' },
  { name: 'Socials', type: 'socials' }, // budete muset doplnit do tailwind.config.js
  { name: 'Koláž', type: 'multiple' },
];

// Předdefinované barvy pozadí
export const bgColors = [
  { name: 'Bílá', code: '#ffffff' },
  { name: 'Černá', code: '#222222' },
  { name: 'Modrá', code: '#1e40af' },
  { name: 'Růžová', code: '#e879f9' },
  { name: 'Žlutá', code: '#fde047' },
  { name: 'Mátová', code: '#86efac' },
];

// Velikosti desky
export const sizes = [
  { label: 'S (20×25 cm)', value: 'S', price: 799 },
  { label: 'L (29×37 cm)', value: 'L', price: 1199 },
];

// Stojánek
export const stands = [
  { label: 'Žádný', value: 'none', price: 0 },
  { label: 'Akrylový', value: 'acryl', price: 79 },
  { label: 'Akrylový masiv', value: 'acryl-masiv', price: 259 },
  { label: 'Dubový masiv', value: 'oak-masiv', price: 259 },
];

// Uchycení na zeď
export const hangings = [
  { label: 'Žádné', value: 'none', price: 0 },
  { label: 'Dubová minipolička', value: 'oak-minishelf', price: 259 },
];

// Balení
export const packagings = [
  { label: 'Základní', value: 'basic', price: 0 },
  { label: 'Dárkové', value: 'gift', price: 249 },
];

export const multipleLayouts = [
  {
    items: 2,
    svg: layoutsSvgPreviews.twoHorizontal,
    name: 'twoHorizontal',
    gridTemplateColumns: '1fr',
    gridTemplateRows: 'repeat(2, 1fr)',
    gridTemplateAreas: `
  "item-1"
  "item-2"
  `,
  },
  {
    items: 3,
    svg: layoutsSvgPreviews.threeHorizontal,
    name: 'threeHorizontal',
    gridTemplateColumns: '1fr',
    gridTemplateRows: 'repeat(3, 1fr)',
    gridTemplateAreas: `
  "item-1"
  "item-2"
  "item-3"
  `,
  },
  {
    items: 3,
    svg: layoutsSvgPreviews.threeBottomTriangle,
    name: 'threeTopTriangle',
    gridTemplateColumns: '1fr 1fr',
    gridTemplateRows: 'repeat(2, 1fr)',
    gridTemplateAreas: `
  "item-1 item-1"
  "item-2 item-3"
  `,
  },
  {
    items: 3,
    svg: layoutsSvgPreviews.threeTopTriangle,
    name: 'threeBottomTriangle',
    gridTemplateColumns: '1fr 1fr',
    gridTemplateRows: 'repeat(2, 1fr)',
    gridTemplateAreas: `
  "item-1 item-2"
  "item-3 item-3"
  `,
  },
  {
    items: 4,
    svg: layoutsSvgPreviews.four,
    name: 'four',
    gridTemplateColumns: '1fr 1fr',
    gridTemplateRows: 'repeat(2, 1fr)',
    gridTemplateAreas: `
  "item-1 item-2"
  "item-3 item-4"
  `,
  },
  {
    items: 4,
    svg: layoutsSvgPreviews.four_sized,
    name: 'four-sized',
    gridTemplateColumns: '2fr 1fr 2fr',
    gridTemplateRows: 'repeat(2, 1fr)',
    gridTemplateAreas: `
  "item-1 item-1 item-2"
  "item-3 item-4 item-4"
  `,
  },
  {
    items: 6,
    svg: layoutsSvgPreviews.six_sized,
    name: 'six-sized',
    gridTemplateColumns: '2fr 1fr 2fr',
    gridTemplateRows: 'repeat(3, 1fr)',
    gridTemplateAreas: `
  "item-1 item-1 item-2"
  "item-3 item-4 item-4"
  "item-5 item-5 item-6"
  `,
  },
  {
    items: 9,
    svg: layoutsSvgPreviews.nine,
    name: 'nine',
    gridTemplateColumns: '1fr 1fr 1fr',
    gridTemplateRows: 'repeat(3, 1fr)',
    gridTemplateAreas: `
  "item-1 item-2 item-3"
  "item-4 item-5 item-6"
  "item-7 item-8 item-9"
  `,
  },
];

export const multipleLayoutsH = [
  {
    items: 2,
    svg: layoutsSvgPreviewsH.twoHorizontal,
    name: 'twoHorizontal',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gridTemplateRows: '1fr',
    gridTemplateAreas: `
  "item-1 item-2"
  `,
  },
  {
    items: 3,
    svg: layoutsSvgPreviewsH.threeHorizontal,
    name: 'threeHorizontal',
    gridTemplateColumns: '2fr 1fr',
    gridTemplateRows: 'repeat(2, 1fr)',
    gridTemplateAreas: `
  "item-1 item-2"
  "item-1 item-3"
  `,
  },
  {
    items: 3,
    svg: layoutsSvgPreviewsH.threeBottomTriangle,
    name: 'threeTopTriangle',
    gridTemplateColumns: '1fr 2fr',
    gridTemplateRows: 'repeat(2, 1fr)',
    gridTemplateAreas: `
  "item-1 item-3"
  "item-2 item-3"
  `,
  },
  {
    items: 4,
    svg: layoutsSvgPreviewsH.threeTopTriangle,
    name: 'threeBottomTriangle',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gridTemplateRows: 'repeat(2, 1fr)',
    gridTemplateAreas: `
  "item-1 item-2"
  "item-3 item-4"
  `,
  },
  {
    items: 4,
    svg: layoutsSvgPreviewsH.four,
    name: 'four',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gridTemplateRows: 'repeat(3, 1fr)',
    gridTemplateAreas: `
  "item-1 item-2"
  "item-1 item-4"
  "item-3 item-4"
  `,
  },
  {
    items: 6,
    svg: layoutsSvgPreviewsH.four_sized,
    name: 'four-sized',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gridTemplateRows: 'repeat(2, 1fr)',
    gridTemplateAreas: `
  "item-1 item-2 item-3"
  "item-4 item-5 item-6"
  `,
  },
  {
    items: 6,
    svg: layoutsSvgPreviewsH.six_sized,
    name: 'six-sized',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gridTemplateRows: 'repeat(3, 1fr)',
    gridTemplateAreas: `
  "item-1 item-2 item-5"
  "item-3 item-2 item-6"
  "item-3 item-4 item-6"
  `,
  },
  {
    items: 9,
    svg: layoutsSvgPreviewsH.nine,
    name: 'nine',
    gridTemplateColumns: '1fr 1fr 1fr',
    gridTemplateRows: 'repeat(3, 1fr)',
    gridTemplateAreas: `
  "item-1 item-2 item-3"
  "item-4 item-5 item-6"
  "item-7 item-8 item-9"
  `,
  },
];

export const MAIN_TEXT_MAX = 120;
export const SMALL_TEXT_MAX = 150;
